import React from 'react';
import { BaseSelector } from '../base/base-selector';
import styles from './font.module.scss';
const FontRenderer = (selectedOption, backgroundColor, selectedOptionText = 'Aa') => (React.createElement("div", { className: styles.selectContainer },
    React.createElement("span", { style: { color: selectedOption } }, selectedOptionText),
    React.createElement("div", { className: styles.fontColorIndicator, style: backgroundColor })));
export const Font = ({ selectedOption, selectedOptionText, ...restProps }) => {
    const backgroundColor = { backgroundColor: selectedOption };
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseSelector, { ...restProps }, FontRenderer(selectedOption, backgroundColor, selectedOptionText))));
};
//# sourceMappingURL=font.js.map